@if (series && series.view_on_flowchart()) {
  <table
    class= 'series-rect'
    [ngStyle]="{'background':series.background(), 'color':series.text_colour(),'font-size.px':series.font_size()}"
    [ngClass]="{'selected-series-rect': series.selected()}">
    <tr>
      @if (series.data.type==='series' && series.show_status()===true) {
        <td [ngStyle]="{'border-color':series.borders(),'padding':series.padding()}"
          (dblclick)="voidEvent($event)">
          <span class="fa flag flag--status"
                  [ngClass]="{'fa-check flag--status-fine': series.status() === 1,
            'fa-warning flag--status-warn': series.status() === 2,
            'fa-warning flag--status-action': series.status() === 3}"></span>
        </td>
      }
      <td style="text-align:right;"
        [ngStyle]="{'border-color':series.borders(),'style.padding':series.padding()}"
        class="series-value">
        {{series.display()}}
      </td>
      <td class="edit-series-component" [ngStyle]="{'border-color':series.borders(),'padding':series.padding()}">
        <inline-style-menu class="menu-component"
          [value_component]="series.data"
          [tree_position]="series.tree_position">
        </inline-style-menu>
      </td>
    </tr>
  </table>
}

@if (group && group.view_on_flowchart) {
  <table class="series-group" [ngClass]="{'selected-group':groups_selected[group.name]}">
    @for (series of group.series; track series) {
      @if (series.view_on_flowchart() === true) {
        <tr
          [ngStyle]="{'background':series.background(), 'color':series.text_colour(),'font-size.px':series.font_size()}"
          [ngClass]="{'selected-series-rect' :series.selected()}"
          >
          @if (group.show_status===true) {
            <td [ngStyle]="{'border-color':series.borders(),'padding':series.padding()}"
              >
              <span class="fa flag flag--status"
                  [ngClass]="{'fa-check flag--status-fine': series.status() === 1,'fa-warning flag--status-warn': series.status() === 2,
            'fa-warning flag--status-action': series.status() === 3}"></span>
            </td>
          }
          <td style="text-align:right;"
            [ngStyle]="{'border-color':series.borders(),'style.padding':series.padding()}"
            class="series-value">
            {{series.display()}}
          </td>
          <td class="edit-series-component" [ngStyle]="{'border-color':series.borders(),'padding':series.padding()}">
            <inline-style-menu class="menu-component"
              [value_component]="series.data"
              [tree_position]="series.tree_position">
            </inline-style-menu>
          </td>
        </tr>
      }
    }
  </table>
}
